import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutContactLookup extends Layout {
    sourceContactLookup: DataSource;
    tableContactLookup: Table;
}
